import { TeamAssignmentDialog } from '@rdrive/plugin-team-assignment';
import setup from './setup.js';

export default {
  name: 'teams-page-assignment',
  props: {
    assignableTeamIds: {
      type: Object,
      required: true
    }
  },
  components: { TeamAssignmentDialog },
  setup,
};
